import { useEffect, useState } from "react";
import { Location } from "history";
import {
  IonHeader,
  IonToolbar,
  isPlatform,
  IonPage,
  IonContent,
  IonTitle,
  IonButtons,
  IonBackButton,
} from "@ionic/react";

import { FormattedMessage, useIntl } from "react-intl";
import IntegrationsChannelsWrapper from "./wrapper";

const isMobile = isPlatform("android") || isPlatform("ios");

const MobileTitle = ({
  backButton,
  id,
}: {
  backButton: string;
  id: string;
}) => {
  return (
    <IonHeader>
      <IonToolbar>
        <IonButtons slot="start">
          <IonBackButton defaultHref={`/settings`} text={backButton} />
        </IonButtons>
        <IonTitle>
          <FormattedMessage id={id} />
        </IonTitle>
      </IonToolbar>
    </IonHeader>
  );
};

const Integrations: React.FC<ILayoutProps> = (props: ILayoutProps) => {
  const [mode, setMode] = useState("");
  const intl = useIntl();

  useEffect(() => {
    if (props.location.pathname === "/connect") {
      setMode("channel");
    } else {
      setMode("location");
    }
  }, [props.location.pathname]);

  return (
    <IonPage id="main-content">
      {isMobile && (
        <MobileTitle
          backButton={intl.formatMessage({ id: "common.back" })}
          id={
            mode === "channel"
              ? "integrations.pageConnectTitle"
              : "integrations.pageTitle"
          }
        />
      )}
      <IonContent
        {...(isMobile
          ? { fullscreen: true, color: "light", className: "ion-padding" }
          : {})}
      >
        <IntegrationsChannelsWrapper mode={mode} location={props.location} />
      </IonContent>
    </IonPage>
  );
};

interface ILayoutProps {
  location: Location;
  mode: string;
}

export default Integrations;
